import { StatusBadge } from './ui/StatusBadge';
import { formatOffset } from '../lib/timeline';
import { purposeLabel } from '../lib/automationLabels';
import type { AutomationTimelineEntry } from '../types/api';

/** Vertical timeline: one node per flow step, offset from enrollment. Used on both the detail
 * panel (read-only, from the API) and the editor's docked preview (recomputed live). */
export function AutomationTimeline({ entries }: { entries: AutomationTimelineEntry[] }) {
  if (entries.length === 0) {
    return <p className="text-muted text-sm m-0">The flow has no steps yet.</p>;
  }

  return (
    <ol className="m-0 p-0 list-none flex flex-col">
      {entries.map((entry, i) => (
        <li key={entry.stepId} className="flex gap-3">
          <div className="flex flex-col items-center flex-shrink-0" aria-hidden="true">
            <span className="w-2.5 h-2.5 rounded-full bg-accent mt-1.5" />
            {i < entries.length - 1 ? (
              <span className="w-px flex-grow bg-border min-h-[28px]" />
            ) : null}
          </div>
          <div className="pb-4 min-w-0">
            <div className="text-xs text-muted font-mono">{formatOffset(entry.offsetSeconds)}</div>
            <div className="text-sm break-words">{entry.description}</div>
            {entry.purpose ? (
              <StatusBadge tone="accent" icon="✉">
                {purposeLabel(entry.purpose)}
              </StatusBadge>
            ) : null}
          </div>
        </li>
      ))}
    </ol>
  );
}
